import get from 'lodash/get';
import localStore from 'store';

import conditionalElements from '../../blocks/elements/element-util/conditional-elements';

import { ELEMENT_TYPE__SOCIAL_INPUT } from '../constants';

const elementsSort = (a, b) => a.getIn(['css', 'order']) - b.getIn(['css', 'order']);

export const selectElementsByParentId = (state, parentId, filters = {}) => {
  let selectedElements = state.elements
    .filter((element) => element.get('parentId') === parentId)
    .sort(elementsSort)
    .toList()
    .toJS();
  if (filters.omitHidden) {
    selectedElements = selectedElements.filter((element) => element.visible === true);
  }
  return selectedElements;
};

export const selectElementsByPageId = (state, pageId) =>
  state.elements
    .filter((element) => element.get('pageId') === pageId)
    .sort(elementsSort)
    .toList()
    .toJS();

export const selectElementsForClient = (state, parentId) =>
  selectElementsByParentId(state, parentId)
    .filter((element) => {
      if (!element.visible) return false;
      if (element.type === ELEMENT_TYPE__SOCIAL_INPUT)
        return get(element, 'properties.providers.length', 0) > 0;
      return true;
    })
    .map(({ id, originalId, properties, ...element }) => {
      const answer = state.answers
        .findLast((a) => a.get('elementId') === id || a.get('originalElementId') === originalId)
        ?.toJS();

      const savedValue = answer?.value ?? localStore.get(id);
      const nextProperties = { ...properties, answer, savedValue };
      return { ...element, id, properties: nextProperties };
    });

export const selectElementByName = (state, name) => {
  const elementFound = state.elements.filter((element) => element.get('name') === name).first();
  return elementFound && elementFound.toJS();
};

export const selectConditionalElements = (state) =>
  state.elements
    .filter((element) => conditionalElements.indexOf(element.get('type')) !== -1)
    .sort((a, b) => a.get('name').localeCompare(b.get('name')))
    .toList()
    .toJS();

export const selectElementById = (state, elementId) => {
  const element = state.elements.get(elementId);
  return element && element.toJS();
};

export const selectElementRefs = (state, elementName) =>
  state.elements
    .filter((element) => JSON.stringify(element.toJS()).indexOf(`#${elementName}`) > -1)
    .toList()
    .toJS();

export const selectElementRefNames = (state, elementName) =>
  selectElementRefs(state, elementName).map((element) => element.name);

export const selectRecentElement = (state) =>
  state.elements.maxBy((element) => element.get('createdAt')).toJS();

export const elementTypeIncludes = (element, types) => {
  const type = get(element, 'type');
  return types.indexOf(type) !== -1;
};
